module.exports = __webpack_public_path__ + "img/rc1.852bf797.png";